import { render } from "./ConfirmMarksButton.vue?vue&type=template&id=0715128d"
import script from "./ConfirmMarksButton.vue?vue&type=script&lang=js"
export * from "./ConfirmMarksButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__